module.exports = __webpack_public_path__ + "static/media/OneM.282a3c51.png";